module.exports = __webpack_public_path__ + "media/theme/step--1--close-1678af60.png";